/**
 * 앱 안의 AI 를 여는 **스위치 하나** — 지금은 꺼져 있다(AI 기능을 제공하지 않는다).
 *
 * 꺼져 있으면 함께 닫힌다:
 * - 화면: AI 작업(`/service/jobs`) · 작업 관리(`/service/task-manage`) · AI chat 보관함(`/service/ai-chat`) ·
 *   컨텐츠 발상(`/service/labs/content-ideation`)은 404, 허브·소재 찾기의 AI chat 담기·독은 안 그린다(잠금 표시도 없다)
 * - Labs: 컨텐츠 플래너의 「신규 생성」·「AI 답변 생성」, 심화검색 일별 하이라이트의 이미지 분석(단추·분석 필터)을 안 그린다
 * - 서버: `api/search-all/job` · `api/search-all/ai-chat` · `api/mcp/job` · `api/labs/reddit-generate` ·
 *   `api/ai/gemini-image-analysis` 는 403 `{ error, reason: 'unavailable' }`,
 *   컨텐츠 발상 서버 액션 둘은 `{ success: false, error }`, `api/mcp/jobs` 는 빈 목록
 * - 알림의 「AI 요약」 항목은 고를 수 없고 저장하면 꺼진다(`constants/alert-rule`)
 *
 * 🔑 코드는 그대로 둔다 — `true` 로 두면 전부 한꺼번에 다시 선다. 그때 플랜별 관문은 플랜 표의 `ai.aiYN` 이다.
 * ⚠️ 꺼진 동안 소개·요금·안내 글에서 AI 작업·AI 질문을 말하지 않는다 — 화면에 없는 것을 팔면 안 된다.
 */
export const AI_FEATURES_OPEN: boolean = false;

/** 닫힌 AI 창구가 돌려주는 한 줄 — 플랜을 올리라고 하지 않는다(어느 플랜에도 없다) */
export const AI_UNAVAILABLE_MESSAGE = '현재 제공하지 않는 기능입니다.';

/** 닫힌 AI 창구의 까닭 표식 — 부르는 쪽(MCP 서버 포함)이 문구 대신 이 값을 읽는다 */
export const AI_UNAVAILABLE_REASON = 'unavailable';

/**
 * 홈 검색칸의 「질문 → 화면」 길잡이 스위치 — `AI_FEATURES_OPEN` 과 따로 연다(이 길잡이만 켜고 끈다).
 *
 * 켜면: 사전 일치도 `@계정`도 아닌 말을 `/api/ask`(`ask.route`)가 화면 하나와 그 화면의 조건으로 읽고, 홈이 그 화면으로 옮긴다.
 * 끄면: 홈 검색은 늘 하던 대로 한 번에 찾기 결과로 간다 · `/api/ask` 는 403.
 * 「보류」 검토용 — 출시 전 결정. ⚠️ 켜 두었다고 소개·요금·안내 글에서 AI 를 말하지 않는다(위 스위치 머리말).
 */
export const ASK_ROUTER_OPEN: boolean = true;
